import React, { useState, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import Container from '../components/common/Container';
import { useTranslation } from 'react-i18next';
import Button from '../components/common/Button';
import RegisterUser from '../components/users/registerUser';
import EditUser from '../components/users/editUser';
import { GET_USERS } from '../graphql/queries';
import { UserState } from '../types/users';
import Loading from '../components/common/Loading';

const Users: React.FC = () => {
    const { t } = useTranslation('users');

    const { loading, error, data, refetch } = useQuery(GET_USERS);

    const [isShowAddUser, setIsShowAddUser] = useState<boolean>(false);
    const [isShowEditUser, setIsShowEditUser] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<UserState>();
    
    const handleShowAddUser = useCallback((isShow: boolean) => {
        setIsShowAddUser(isShow);
        setIsShowEditUser(false);
        if(!isShow)
            refetch();
    }, []);

    const handleShowEditUser = useCallback((isShow: boolean) => {
        setIsShowEditUser(isShow);
        setIsShowAddUser(false);
        if(!isShow)
            refetch();
    }, []);
    
    if (loading) return <Loading />;
    if (error) return <p className="text-center mt-4 text-red-500">Error: {error.message}</p>;

    return (
        <Container label={t('users')}>
            <table>
                <thead>
                    <tr>
                        <th>{t('username')}</th>
                        <th>{t('department')}</th>
                        <th>{t('job')}</th>
                        <th>{t('mail address')}</th>
                        <th>{t('permission')}</th>
                        <th>{t('actions')}</th>
                    </tr>
                </thead>
                {data.allUsers.map((value: UserState, index: number) => {
                    return (
                        <tr key={index}>
                            <td>{value.name}</td>
                            <td>{value.division}</td>
                            <td>{value.position}</td>
                            <td>{value.email}</td>
                            <td>{t(value.role)}</td>
                            <td>
                                <Button
                                    label={t('edit')}
                                    onClick={() => {
                                        setSelectedUser(value);
                                        handleShowEditUser(true);
                                    }}
                                />
                            </td>
                        </tr>
                    )
                })}
            </table>
            <div className="mt-2">
                <Button
                    label={t('add new user')}
                    onClick={() => handleShowAddUser(true)}
                />
            </div>
            {isShowAddUser && <RegisterUser closeCreateForm={() => handleShowAddUser(false)} />}
            {isShowEditUser && selectedUser && <EditUser selectedUser={selectedUser} closeEditForm={() => handleShowEditUser(false)} />}
        </Container>
    );
};

export default Users;
